export const weekDayName = {
	1: 'Δευτέρα',
	2: 'Τρίτη',
	3: 'Τετάρτη',
	4: 'Πέμπτη',
	5: 'Παρασκευή',
	6: 'Σάββατο',
	0: 'Κυριακή',
};
export const getHumanTotalLoggedInTime = minutes => {
	if (minutes < 60) {
		return `${minutes} λεπτά`;
	}

	const hours = minutes / 60;
	const rHours = Math.floor(hours);
	const mins = (hours - rHours) * 60;
	const rMins = Math.round(mins);
	return `${rHours} ώρες και ${rMins} λεπτά`;
};

export const transformPhoneSoft = input => {
	try {
		let inputModified = input;
		if (input?.length >= 3 && input?.startsWith?.('+30')) {
			inputModified = inputModified.substring(3, input.length);
		} else if (input?.length >= 2 && input?.startsWith?.('30')) {
			inputModified = inputModified.substring(2, input.length);
		}

		return inputModified;
	} catch (error) {
		console.log('transformPhoneSoft err:', error);
	}
};

// Whether the shop charge (order.shopFee — what the shop pays Delivery Man) may
// be shown to this user. The city has to run the shop-charge system at all, and
// a city can additionally hide the charge from the shop accounts: the account is
// usually shared with the staff and an owner may not want them to see it. For a
// shop the server strips the amounts too, so this only keeps the columns and
// totals from showing up empty.
//
// The shop may carry its own answer, which wins over the city's — `??` and not
// `||` because an explicit false ("show it to this one shop") is a real answer
// and only null/undefined means "follow the city". For a shop account the
// override rides on the profile, next to requiredOrderFields.
//
// An individual admin can be hidden from it too (admin.hideShopFees, set on the
// admin's own form) — a dispatcher who runs the board but has no business seeing
// what each shop is billed. That one is display-only: the live board reaches
// every admin of a city over one shared socket, so the server cannot strip the
// amounts per admin the way it does per shop. Masters always see it.
export const canSeeShopFees = user => {
	if (!user?.cityLocation?.withShopFees) {
		return false;
	}

	if (user?.role === 'admin') {
		return !user?.hideShopFees;
	}

	if (user?.role !== 'shop') {
		return true;
	}

	return !(user?.hideShopFeesFromShops ?? user?.cityLocation?.hideShopFeesFromShops);
};
